import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2 } from "lucide-react";
import { PageHeader, fmtUSD, fmtDate, Empty } from "../../components/admin/ui";

const Donors = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/donors").then((r) => setItems(r.data.donors || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-donors">
      <PageHeader
        overline="Stewardship"
        title={<>Covenant <span className="italic gold-text">Partners</span></>}
        subtitle="Aggregated from confirmed donations only. Every record is real."
      />
      {loading ? (
        <div className="text-[#D9D9D9]/60"><Loader2 className="inline h-4 w-4 animate-spin mr-2" /> Loading…</div>
      ) : items.length === 0 ? (
        <Empty title="No donors yet" subtitle="Once gifts come in via Stripe or are logged manually, donors appear here ranked by total given." />
      ) : (
        <div className="bento-card !p-0 overflow-hidden">
          <span className="glow-blob" />
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[10px] tracking-[0.22em] uppercase text-[#C9A44C] border-b border-[#C9A44C]/15">
                  <th className="px-6 py-4">Donor</th>
                  <th className="px-6 py-4 hidden md:table-cell">Email</th>
                  <th className="px-6 py-4">Total Given</th>
                  <th className="px-6 py-4">Gifts</th>
                  <th className="px-6 py-4 hidden lg:table-cell">First Gift</th>
                  <th className="px-6 py-4 hidden lg:table-cell">Last Gift</th>
                  <th className="px-6 py-4 hidden md:table-cell">Platforms</th>
                </tr>
              </thead>
              <tbody>
                {items.map((d, i) => (
                  <tr key={`${d.donor_email}-${i}`} className="border-b border-[#C9A44C]/8 hover:bg-[#C9A44C]/5">
                    <td className="px-6 py-4 text-[#F6F0E6]">{d.donor_name || "Anonymous"}</td>
                    <td className="px-6 py-4 hidden md:table-cell text-[#D9D9D9]/80">{d.donor_email || "—"}</td>
                    <td className="px-6 py-4 font-serif-display text-lg gold-text">{fmtUSD(d.total_given)}</td>
                    <td className="px-6 py-4 text-[#F6F0E6]">{d.gift_count}</td>
                    <td className="px-6 py-4 hidden lg:table-cell text-[#D9D9D9]/70">{fmtDate(d.first_gift_at)}</td>
                    <td className="px-6 py-4 hidden lg:table-cell text-[#D9D9D9]/70">{fmtDate(d.last_gift_at)}</td>
                    <td className="px-6 py-4 hidden md:table-cell">
                      <div className="flex flex-wrap gap-1">
                        {d.platforms.map((p) => <span key={p} className="text-[10px] tracking-[0.16em] uppercase border border-[#C9A44C]/25 rounded-full px-2 py-0.5 text-[#C9A44C]">{p}</span>)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Donors;
